__turbopack_context__.v({
  "customControls": "CustomPlayButton-module-scss-module__2n9i6a__customControls",
  "customVideoControls": "CustomPlayButton-module-scss-module__2n9i6a__customVideoControls",
  "playButtonOverlay": "CustomPlayButton-module-scss-module__2n9i6a__playButtonOverlay",
  "playButton__circle": "CustomPlayButton-module-scss-module__2n9i6a__playButton__circle",
  "playButton__icon": "CustomPlayButton-module-scss-module__2n9i6a__playButton__icon",
  "playButton__loading": "CustomPlayButton-module-scss-module__2n9i6a__playButton__loading",
  "progressBar": "CustomPlayButton-module-scss-module__2n9i6a__progressBar",
  "progressBar__fill": "CustomPlayButton-module-scss-module__2n9i6a__progressBar__fill",
  "progressBar__track": "CustomPlayButton-module-scss-module__2n9i6a__progressBar__track",
  "showingPlayButton": "CustomPlayButton-module-scss-module__2n9i6a__showingPlayButton",
  "spin": "CustomPlayButton-module-scss-module__2n9i6a__spin",
  "videoClickArea": "CustomPlayButton-module-scss-module__2n9i6a__videoClickArea",
  "videoPlaying": "CustomPlayButton-module-scss-module__2n9i6a__videoPlaying",
});
